import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Configure axios to include credentials with all requests
axios.defaults.withCredentials = true;

export default axios;
